module.exports = "label{margin-bottom:6px;margin-top:10px}\n"